import {PatientCommandParams} from "./PatientCommandParams";
import {Command} from "./Command";
import { NCZIExtension } from '../Interfaces/ncziTypes';

export type CancelExaminationResultParams = PatientCommandParams & {
    type: string
    examination: {
        previousVersion: NCZIExtension
        versionSetId: NCZIExtension | undefined
        sensitivity: number
        uncertaintyExpressed: boolean
        createdAt: string
        versionStatus: string
    }
};

export const CancelExaminationResult = (params: CancelExaminationResultParams): Command => {
    return {
        operation: 'StornujZaznamOVysetreni_v7',
        params
    }
}